import React, {useContext} from 'react';
import { Context } from './Context';

export default function Result() {
    const { Winner, goodAnswer, tryAgain } = useContext(Context);

    return (
        <div className="winner"> 
            <img className="winner--img" width="236px" src={Winner}/>
            <h2>Results</h2>
            <p>You got <strong>{goodAnswer}</strong> good {goodAnswer <= 1 ? "answer" : "anwers"}</p>
            <button className="try--btn" onClick={tryAgain}>Try again</button>
        </div>
    )
}
